import * as requestFromServer from "./TeacherCoursesCrud";
import { callTypes, teacherCourseSlice } from "./TeacherCoursesSlice";

const {actions} = teacherCourseSlice;

export const getTeacherCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeacherCourses(queryParams)
    .then(response => {
      dispatch(actions.coursesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTeacherCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllTeacherCourses(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getTeachersWithBranches = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getTeachersWithBranches(term)
    .then(response => {
      dispatch(actions.teachersWithBranchesFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSectionsAndCourses = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  return requestFromServer
    .getSectionsAndCourses(queryParams)
    .then(response => {
      dispatch(actions.sectionsAndCoursesFetched(response.data));
    })
    .catch(error => {
        
    });
};

export const getAllList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllList()
    .then(response => {
      dispatch(actions.allListFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSections = level => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));

  if (level === undefined) {
    return requestFromServer
      .getAllSections()
      .then(response => {
        dispatch(actions.sectionsFetched(response.data));
      })
      .catch(error => {
        
      });
  }

  return requestFromServer
    .getSections(level)
    .then(response => {
      dispatch(actions.sectionsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getSectionAndCourseIds = (teacherId, term) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getSectionAndCourseIds(teacherId, term)
    .then(response => {
      dispatch(actions.sectionAndCourseIdsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveTeacherCourses = (teacherId, term, ids) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .saveTeacherCourses(teacherId, term, ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });    
};

export const deleteTeacherCourses = ids => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .deleteTeacherCourses(ids)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const cleanSectionAndCourseIds = () => dispatch => {
  dispatch(actions.sectionAndCourseIdsCleaned());
};

export const cleanTeacherCoursesState = () => dispatch => {
  dispatch(actions.coursesStateCleaned());
};